export class MouseState {
    constructor() {
        this.buttons = 0;
        document.addEventListener("pointerdown", this._pointerDownHandler.bind(this));
        document.addEventListener("pointerup", this._pointerUpHandler.bind(this));
    }
    _pointerDownHandler() {
        this.buttons = 1;
    }
    _pointerUpHandler() {
        this.buttons = 0;
    }
}
export const mouseState = new MouseState();
//# sourceMappingURL=MouseState.js.map